module.exports = __webpack_public_path__ + "img/IOLI_logo GR.df65e6b9.jpg";